(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name fuel.controller:FuelCtrl
   *
   * @description
   *
   */
  angular
    .module('fuel')
    	.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('FuelUpliftReportCtrl', FuelUpliftReportCtrl);

  function FuelUpliftReportCtrl(applicationConstants,CommonMasterData,CommonFuelService,FuelUpliftService,MessageService) {
    var vm = this;
    vm.ctrlName = 'FuelUpliftReportCtrl';
    
    vm.model = {
            searchPanelToggle:true,
            searchCriteria:null,
            masterList: {
                cityList:[],
                fromDateAfterToDate : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
            },
            fuelUpliftList:[],
            initialSearchDone:false,
            selectedSupplier:null,
            selectedSupplierFromSubmit:null,
            editorMode: applicationConstants.EDITOR_STATUS.ADD
        };
    
    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };
    
    vm.changeCriteria = function () {
        if (vm.model.initialSearchDone === true) {
            vm.model.fuelUpliftList = FuelUpliftService.refineData(vm.model.searchCriteria);
        }
    };

 // on change search field
	vm.changeSearchField = function(searchParams, flag) {
		if(flag === 'fromDate' || flag === 'toDate'){ 
			setDateValidationFlags();				
			var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
        	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
        		searchParams.toDate = tempFromDate;                		
        	}
			if(!!searchParams.fromDate && !!searchParams.toDate 
					&& !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				}else{
					vm.model.masterList.fromDateAfterToDate = false;
				}
			}
			
		}
	}; 
	
	// check from date and to date
	function istoDateBeforeFromDate() {
		return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
				.isBefore(
						moment(vm.model.searchCriteria.fromDate,
								"DD/MM/YYYY"));
	}
	;
	
	function setDateValidationFlags(){
		//if from date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
			vm.model.masterList.fromDateAfterToDate = false;
			vm.model.masterList.fromDateFormatInvalid = true;
		}else{
			vm.model.masterList.fromDateFormatInvalid = false;
		}
		
		//if to date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
			vm.model.masterList.fromDateAfterToDate = false;
			vm.model.masterList.toDateFormatInvalid = true;
		}else{
			vm.model.masterList.toDateFormatInvalid = false;
		}
	}
	
	function isDateFormatInvalid(date){ 
		if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
			return true;
		}
		return false;
	}

    vm.submitSearch = function (params) {
        if(isValidSearchParams(params)){
        	vm.model.initialSearchDone=true;
            vm.model.fuelUpliftList = [];
            vm.model.searchCriteria = params;
            FuelUpliftService.setUpliftSearchCriteria(vm.model.searchCriteria);
            FuelUpliftService.getFuelUplift(
                function (UpliftList) {
                    vm.model.fuelUpliftList = UpliftList;
                    vm.model.searchPanelToggle = false;
                    if(vm.model.fuelUpliftList.length===0){
                        MessageService.error('No records found');
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
    };
    
  //validate search Params
	function isValidSearchParams(params) {
		setDateValidationFlags();
		// if date invalid
		if(vm.model.masterList.fromDateFormatInvalid  || vm.model.masterList.toDateFormatInvalid){
			vm.model.masterList.fromDateAfterToDate = false;
			return false;
		}else if (istoDateBeforeFromDate()) {
			vm.model.masterList.fromDateAfterToDate = true; 
			return false;
		}
		vm.model.masterList.fromDateAfterToDate = false; 
		return true;
	}
    
    CommonMasterData.getAirportList(function(cityList){
        vm.model.masterList.cityList = cityList;
        vm.model.searchCriteria = FuelUpliftService.getSearchCriteria();
    },function () {});
    
    
  }
}());
